import {addQueryArgs} from '@wordpress/url';

let removeEditorPanel;
if (wp.data) {
    removeEditorPanel = wp.data.dispatch('core/edit-post').removeEditorPanel;
}


const perPage = 100;
const {taxonomies = []} = REALPRESS_ADMIN_SINGLE_PROPERTY_OBJECT;
const postTerms = REALPRESS_ADMIN_SINGLE_PROPERTY_OBJECT.post_terms || [];
let isActived = false;

const realpressPropertyTaxonomy = () => {
    const taxonomyTabNode = document.querySelector('#realpress_taxonomy_tab');
    //---Remove taxonomy gutenberg block---
    if (removeEditorPanel) {
        for (let i = 0; i < taxonomies.length; i++) {
            wp.domReady(() => {
                removeEditorPanel(`taxonomy-panel-${taxonomies[i]}`);
            });
        }
    }

    //-------------------end---------------

    taxonomyTabNode.addEventListener('click', function () {
        handleActiveTaxonomyTab();
    });

    if (taxonomyTabNode.classList.contains('active')) {
        handleActiveTaxonomyTab();
    }

    //---------Search-------
    const searchFilters = document.querySelectorAll('.realpress-add-taxonomy-filter');
    for (let i = 0; i < searchFilters.length; i++) {
        const searchFilterNode = searchFilters[i];
        const searchInputNode = searchFilterNode.querySelector('.realpress-search-input');
        const searchButtonNode = searchFilterNode.querySelector('button');

        searchInputNode.addEventListener('keyup', function (event) {
            if (event.keyCode === 13) {
                searchButtonNode.click();
            }
        });
        searchButtonNode.addEventListener('click', function (event) {
            event.preventDefault();
            const searchValue = searchInputNode.value;
            const content = this.closest('.realpress-taxonomy-content');
            const taxonomy = content.getAttribute('data-taxonomy');
            content.querySelector('.realpress-add-taxonomy-term-list').innerHTML = '';
            displayLoading(taxonomy);
            getData(taxonomy, {search: searchValue});
        });
    }
};

const fetchTerm = async (taxonomy, query, term) => {
    const result = await wp.apiFetch({
        path: addQueryArgs(`/wp/v2/${taxonomy}`, query),
    });

    term = [...term, ...result];
    if (result.length === perPage) {
        query.page++;
        return await fetchTerm(taxonomy, query, term);
    }
    return term;
};

//---------fetch Data-------
const getData = (taxonomy, args = {}) => {
    const getTerm = async () => {
        try {
            const taxonomyContentNode = document.querySelector(`.realpress-taxonomy-content[data-taxonomy =${taxonomy}]`);
            if (!args || !args.page) {
                args.page = 1;
            }
            // /wp/v2/${taxonomy}?context=view&per_page=100&orderby=name&order=asc&_fields=id,name,parent
            const query = {
                context: 'view',
                per_page: perPage,
                orderby: 'name',
                order: 'asc',
                _fields: 'id,name,parent',
                ...args,
            };

            fetchTerm(taxonomy, query, []).then(function (term) {
                let displayedTerm = term;
                //terms of taxonomy and post
                const terms = postTerms[taxonomy];
                let html = '';
                let check = '';
                for (let i = 0; i < term.length; i++) {
                    if (term[i].parent === 0) {
                        if (!!terms) {
                            check = terms.includes(term[i].id) ? 'checked' : '';
                            term.push();
                        }
                        displayedTerm = displayedTerm.filter(function (obj) {
                            return obj.id !== term[i].id;
                        });
                        html += `<div class="realpress-taxonomy-term-parent">
						<input type="checkbox" id="${taxonomy}-${term[i].id}"
							   name="tax_input[${taxonomy}][]" value="${term[i].id}" ${check}/>
						<label for="${taxonomy}-${term[i].id}">${term[i].name}</label>
					</div>`;
                        const parent = term[i];
                        term.forEach(function (item) {
                            if (item.parent === parent.id) {
                                if (!!terms) {
                                    check = terms.includes(item.id) ? 'checked' : '';
                                }
                                displayedTerm = displayedTerm.filter(function (obj) {
                                    return obj.id !== item.id;
                                });
                                html += `<div class="realpress-taxonomy-term-child">
									<input type="checkbox" id="${taxonomy}-${item.id}"
										   name="tax_input[${taxonomy}][]" value="${item.id}" ${check}/>
									<label for="${taxonomy}-${item.id}">${item.name}</label>
								</div>`;
                            }
                        });
                    }
                }
                if (!!displayedTerm) {
                    displayedTerm.forEach(function (item) {
                        if (!!terms) {
                            check = terms.includes(item.id) ? 'checked' : '';
                        }
                        html += `<div class="realpress-taxonomy-term-child">
									<input type="checkbox" id="${taxonomy}-${item.id}"
										   name="tax_input[${taxonomy}][]" value="${item.id}" ${check}/>
									<label for="${taxonomy}-${item.id}">${item.name}</label>
								</div>`;
                    });
                }
                html += `</div>`;
                //Hide loading
                hideLoading(taxonomy);
                taxonomyContentNode.querySelector('.realpress-add-taxonomy-term-list').innerHTML = html;

                if (['realpress-status', 'realpress-energy-class'].includes(taxonomy)) {
                    handleTermSelect(taxonomyContentNode);
                }
                isActived = true;
            });
            //------------End search--------------
        } catch (e) {
            console.error(e);
        }
    };
    getTerm();
};
const handleActiveTaxonomyTab = () => {
    if (isActived === false) {
        //localize script
        for (let i = 0; i < taxonomies.length; i++) {
            displayLoading(taxonomies[i]);
            getData(taxonomies[i]);
        }
    }
};

//---------------Loading----------------
const displayLoading = (taxonomy) => {
    document.querySelector(`#${taxonomy}-loading`).classList.add('realpress-loading-display');
    setTimeout(() => {
        document.querySelector(`#${taxonomy}-loading`).classList.remove('realpress-loading-display');
    }, 5000);
};

const hideLoading = (taxonomy) => {
    document.querySelector(`#${taxonomy}-loading`).classList.remove('realpress-loading-display');
};

//Allow select only one term of status and energy class
const handleTermSelect = (taxonomyContentNode) => {
    const termNodes = taxonomyContentNode.querySelectorAll('input[type="checkbox"]');
    for (let i = 0; i < termNodes.length; i++) {
        const termNode = termNodes[i];
        termNode.addEventListener('click', function () {
            let isChecked = termNode.checked;
            for (let j = 0; j < termNodes.length; j++) {
                if (termNodes[j].checked) {
                    termNodes[j].checked = false;
                }
            }
            if (isChecked) {
                termNode.checked = true;
            }
        });
    }
}

export default realpressPropertyTaxonomy;
